import { useSortable } from '@dnd-kit/sortable';

/**
 * Thin useSortable wrapper for a module tree row.
 * Does not apply CSS transforms to the row (avoids fighting MUI Collapse).
 */
export function useSortableRow({
  id,
  parentId = null,
  label = '',
  siblingIds = [],
  disabled = false,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging,
    isOver,
    active,
    over,
  } = useSortable({
    id: String(id),
    disabled,
    animateLayoutChanges: () => false,
    data: {
      parentId: parentId ?? null,
      label,
      siblingIds,
    },
  });

  let insertEdge = null;
  if (
    isOver &&
    active &&
    over &&
    String(active.id) !== String(id) &&
    String(active.data?.current?.parentId ?? '') === String(parentId ?? '')
  ) {
    const siblings = active.data?.current?.siblingIds || siblingIds;
    const activeIndex = siblings.indexOf(String(active.id));
    const overIndex = siblings.indexOf(String(id));
    if (activeIndex >= 0 && overIndex >= 0) {
      insertEdge = activeIndex < overIndex ? 'bottom' : 'top';
    }
  }

  return {
    setNodeRef,
    dragHandleProps: disabled ? {} : { ...attributes, ...listeners },
    isDragging,
    insertEdge,
  };
}
